import { Link } from "react-router-dom";
import BulbIcon from "../../Assets/Icons/BulbIcon";
import ChartIcon from "../../Assets/Icons/ChartIcon";
import HandShakeIcon from "../../Assets/Icons/HandShakeIcon";
import ListIcon from "../../Assets/Icons/ListIcon";
import PeopleIcon from "../../Assets/Icons/PeopleIcon";
import BackBtn from "../../Components/BackBtn/BackBtn";
import EquipImg from "../../Assets/Images/Equip1.png";
import TeamImg from "../../Assets/Images/CareersRightImg.jpg";
import SEO from "../../Components/SEO";
import "./careers.css";
const Careers = () => {
  return (
    <div className="careers-wrapper">
      <SEO
        title="BWC Sports | Careers"
        description=""
        url="https://bwcsports.com/careers"
      />
      <div className="careers-page-layout">
        <div className="cp-header-banner">
          <div className="cp-header">
            <div className="cp-back-btn">
              <BackBtn />
            </div>
            <h1>Careers</h1>
          </div>
        </div>

        <div className="cp-body border-clip">
          <div className="cp-join-team black-text-clip">
            <h2>Join Our Team</h2>
            <p>
              Are you passionate about sports and inspiring the next generation
              of athletes?
            </p>
            <p>
              BWC Sports is looking for dedicated Activity Sports Instructors
              (Part-Time/Full-Time) to join our team!
            </p>
            <p>
              At BWC Sports, we believe our people are our greatest asset. We
              foster a diverse, inclusive, and empowering environment where
              coaches and athletes alike can thrive. Whether you’re just
              starting your career or looking for your next big step, we provide
              opportunities for growth, impact, and community building.
            </p>
            <div className="cp-looking-list">
              <h2 className="black-text-clip">Why Work With Us?</h2>
              <p className="black-text-clip">
                <ListIcon />
                Enthusiastic and knowledgeable sports instructors
              </p>
              <p className="black-text-clip">
                <ListIcon />
                Passion for working with young athletes
              </p>
              <p className="black-text-clip">
                <ListIcon />
                Commitment to fostering a positive sports environment
              </p>
            </div>
          </div>
          <div className="cp-right-bg">
            <img src={TeamImg} alt="Team" />
          </div>
        </div>

        <div className="cp-whywork">
          <div className="cp-w-blurb-list">
            <div className="cp-blurb-item">
              <span className="cp-blurb-icon">
                <BulbIcon />
              </span>
              <h3>
                INNOVATIVE <br />
                CULTURE
              </h3>
              <p className="black-text-clip">
                Embrace creativity and innovation
              </p>
            </div>
            <div className="cp-blurb-item">
              <span className="cp-blurb-icon">
                <ChartIcon />
              </span>
              <h3>
                CAREER
                <br /> GROWTH
              </h3>
              <p className="black-text-clip">Access training and development</p>
            </div>
            <div className="cp-blurb-item">
              <span className="cp-blurb-icon">
                <PeopleIcon />
              </span>
              <h3>
                COLLABORATIVE
                <br /> ENVIRONMENT
              </h3>
              <p className="black-text-clip">
                Embrace creativity and innovation
              </p>
            </div>
            <div className="cp-blurb-item">
              <span className="cp-blurb-icon">
                <HandShakeIcon />
              </span>
              <h3>
                COMMUNITY
                <br /> ENGAGEMENT
              </h3>
              <p className="black-text-clip">
                Contribute to impactful initiatives
              </p>
            </div>
          </div>
        </div>

        <div className="cp-apply">
          <div className="cp-apply-cnt">
            <h2>HOW TO APPLY</h2>
            <p className="black-text-clip">
              Ready to join us? Apply by sending your resume and cover letter to
              <Link to="mailto:becausewecansports@gmail.com">
                &nbsp;becausewecansports@gmail.com
              </Link>
            </p>
            <p className="black-text-clip">We look forward to hearing from you!</p>
          </div>
          <div className="cp-apply-img">
            <img src={EquipImg} alt="Equipment" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Careers;
